






































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import {
  UploadFile,
  EditTem,
  GetOptions,
  GetTem,
  GetSizhenType,
  EditSizhenType,
  AddOneSelect,
  GetOneSelectList,
} from "@/request/common";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    Header,
    LeftNav,
    LeaveConfirm,
  },
})
export default class Name extends Vue {
  private hasSave: any = false; // 用来拦截未保存提示
  private ifShowSaveConfirm: any = false;
  private data: any = {
    data: [
      {
        correct: null,
        key: "",
        title: "",
        type: "",
        options: [],
      },
    ],
  };
  private type: any = "";
  private types: any = [];
  private name: any = "";
  private maiTypes: any = [
    "浮脉类",
    "沉脉类",
    "迟脉类",
    "数脉类",
    "虚脉类",
    "实脉类",
  ];
  private editFenleiData: any = [];
  private ifShowFenlei: any = false;
  private ifShowAdd: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private openAddOneSelect() {
    this.name = "";
    this.ifShowAdd = true;
  }
  private addOneSelect() {
    if (!this.name) {
      this.$message.warning("请输入脉象名称");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      template_type: "脉",
      label: this.name,
    };
    AddOneSelect(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("新增成功");
        this.ifShowAdd = false;
        this.getOneSelectList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getOneSelectList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        类别: "脉",
      },
    };
    GetOneSelectList(this, params, loading).then((res: any) => {
      loading.close();
      this.data.data[0].options = this.shuffle(res);
    });
  }
  // 打乱选项顺序
  private shuffle(arr: any) {
    // 复制原数组避免直接修改
    const newArr = [...arr];
    // Fisher-Yates 洗牌算法打乱数组
    for (let i = newArr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    // 重新设置value为索引值
    return newArr.map((item, index) => ({
      label: item.label,
      value: index,
    }));
  }

  private reset() {
    this.data["脉诊设置"] = {
      寸: 20,
      关: 20,
      尺: 20,
      脉压: 20,
      脉幅: 20,
    };
  }
  private getSavePayload() {
    const payload = { ...this.data };
    if (this.type !== "脉") {
      [
        "脉诊设置",
        "脉象图谱",
        "脉象命令原始编号",
        "脉诊实训分类",
        "脉象波形数据",
      ].forEach((key) => delete payload[key]);
    }
    return payload;
  }
  private stripPulseOnlyFields() {
    if (this.type === "脉") {
      return;
    }
    [
      "脉诊设置",
      "脉象图谱",
      "脉象命令原始编号",
      "脉诊实训分类",
      "脉象波形数据",
    ].forEach((key) => delete this.data[key]);
  }
  private async checkDevice() {
    console.log("检查", "check_hand", "检查");
    const checkResult = await window.electronMyAPI.changePulse(
      "检查",
      "check_hand",
      "检查"
    );
    console.log(checkResult);
    const loadingCheck = this.$loading({
      lock: true,
      text: "设备检查中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (checkResult) {
      console.log(checkResult);
      if (checkResult == "success") {
        alert("设备运行正常");
        loadingCheck.close();
      } else {
        loadingCheck.close();
        alert("设备不存在");
      }
    }
  }
  private async controlDevice() {
    const option = this.data.data[0].options.find(
      (item: any) => item.value === this.data.data[0].correct
    );
    const val: any = option ? option.label : "";
    console.log(val, "control_hand", "start");
    const result = await window.electronMyAPI.changePulse(
      val,
      "control_hand",
      "start"
    );
    console.log(result);
  }
  private async closeDevice() {
    console.log("停止", "control_hand", "stop");
    const result = window.electronMyAPI.changePulse(
      "停止",
      "control_hand",
      "stop"
    );
    console.log(result);
  }

  private typeChange(e: any) {
    if (e == "单选") {
      this.data.data[0].correct = "";
    } else {
      this.data.data[0].correct = [];
    }
  }
  private addOneXuanxiang() {
    if (!this.data.data[0]["options"]) {
      this.data.data[0]["options"] = [];
    }
    this.data.data[0]["options"].push({
      label: "",
      value: this.data.data[0].options.length,
    });
  }
  private openFenlei() {
    this.editFenleiData = JSON.parse(JSON.stringify(this.types));
    this.ifShowFenlei = true;
  }
  private addFenlei() {
    this.editFenleiData.push({
      名称: "",
    });
    this.$forceUpdate();
  }
  private delOne(index: any) {
    // 删除一个选项
    this.data.data[0].options.splice(index, 1);
    // 重置正确答案
    if (this.data.data[0].type == "单选") {
      this.data.data[0].correct = "";
    } else {
      this.data.data[0].correct = [];
    }

    // 重新生成索引值
    this.data.data[0].options.forEach((ele: any, index: any) => {
      ele.value = index;
    });
  }
  private delOneFenlei(index: any) {
    this.editFenleiData.splice(index, 1);
    this.$forceUpdate();
  }
  private addFenleiSure() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditSizhenType(this, this.editFenleiData, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("保存成功");
        this.ifShowFenlei = false;
        this.getFenlei();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getFenlei() {
    GetSizhenType(this).then((res: any) => {
      this.types = res;
    });
  }
  private preview(url: any) {
    window.open(url);
  }
  private delImg(index: any) {
    this.data.pic_urls.splice(index, 1);
    this.$forceUpdate();
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        if (this.type == "舌" || this.type == "面" || this.type == "脉") {
          this.data.pic_urls = [res.full_file_url];
        } else {
          if (!this.data.pic_urls) {
            this.data.pic_urls = [];
          }
          this.data.pic_urls.push(res.full_file_url);
        }
        this.$forceUpdate();
      })
      .catch(() => {
        loading.close();
      });
  }
  private uploadTupu(file: any, type: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        this.data["脉象图谱"][type] = res.full_file_url;
        this.$forceUpdate();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getOption() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        类别: this.type,
      },
    };
    GetOptions(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data.data = res;
        console.log("打乱顺序");
        console.log(this.shuffle(res[0].options));
        if (this.type == "脉") {
          this.data["脉象图谱"] = {
            压力趋势图: "",
            脉长图: "",
            脉宽图: "",
            脉幅图: "",
          };
          this.data["脉诊设置"] = {
            寸: 20,
            关: 20,
            尺: 20,
            脉压: 20,
            脉幅: 20,
          };
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private save() {
    return new Promise((resolve, reject) => {
      if (!this.data["名称"]) {
        this.$message.warning("请输入名称");
        return;
      }
      if (this.type == "四诊") {
        if (!this.data.data[0].key) {
          this.$message.warning("请选择分类");
          return;
        }
        if (!this.data.data[0].type) {
          this.$message.warning("请选择题目类型");
          return;
        }
        if (
          this.data.data[0].type != "填空" &&
          (!this.data.data[0].options || this.data.data[0].options.length == 0)
        ) {
          this.$message.warning("请添加选项");
          return;
        }
        // 判断选项不能重复以及选项内容不能为空
        const d = this.data.data[0].options;
        let optionArr: any = [];
        for (let i = 0; i < d.length; i++) {
          // 如果重复或者有空的需要弹提示
          if (!d[i].label) {
            this.$message.warning("选项不能为空");
            return;
          }
          if (optionArr.indexOf(d[i].label) != -1) {
            this.$message.warning("选项不能重复");
            return;
          }
          optionArr.push(d[i].label);
          d[i].id = d[i].label;
        }
        if (!this.data.data[0].title) {
          this.data.data[0].title = this.data.data[0].key;
        }
        if (!this.data["四诊实训分类"]) {
          this.data["四诊实训分类"] = this.data.data[0].key;
        }
      } else {
        if (!this.data.pic_urls || this.data.pic_urls.length == 0) {
          this.$message.warning("请上传图片");
          return;
        }
      }
      if (!this.data["类别"]) {
        this.data["类别"] = this.type;
      }
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      EditTem(this, this.getSavePayload(), loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("保存成功");
          this.hasSave = true;
          this.$router.back();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private getDetail() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        question_template_id: this.data.question_template_id,
      },
    };
    GetTem(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res;
        this.stripPulseOnlyFields();
        console.log(this.data);
      })
      .catch(() => {
        loading.close();
      });
  }
  // 保存确认弹框保存
  private changeSave() {
    this.ifShowSaveConfirm = false;
    this.save().then(() => {
      this.$router.back();
    });
  }
  // 保存确认弹框不保存,切换
  private changeConfirmed() {
    this.ifShowSaveConfirm = false;
    this.hasSave = true;
    this.$router.back();
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    if (!this.hasSave) {
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  private mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.id) {
      this.data.question_template_id = this.$route.query.id;
      this.getDetail();
    } else {
      if (this.type != "四诊") {
        this.getOption();
      }
    }
    if (this.type == "四诊") {
      this.getFenlei();
    }
  }
}
